// src/pages/Cart.js

import React, { useContext } from 'react';
import { FaTrash, FaPlus, FaMinus } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import './Cart.css';
import Footer from '../components/Footer';
import Header from '../components/Header';
import { CartContext } from '../context/CartContext';

const Cart = () => {
  const { cart, updateQuantity, removeFromCart } = useContext(CartContext);

  const handleIncrement = (id) => {
    const item = cart.find((item) => item.id === id);
    if (item) {
      updateQuantity(id, item.quantity + 1);
    }
  };

  const handleDecrement = (id) => {
    const item = cart.find((item) => item.id === id);
    if (item && item.quantity > 1) {
      updateQuantity(id, item.quantity - 1);
    }
  };

  const getSubtotal = () => {
    return cart.reduce((total, item) => total + item.price * item.quantity, 0);
  };

  const getShippingCost = () => {
    return getSubtotal() < 75 && getSubtotal() > 0 ? 10 : 0;
  };

  const getGrandTotal = () => {
    return (getSubtotal() + getShippingCost()).toFixed(2);
  };

  const handleCheckout = () => {

  

    let payloadItems = cart.map((item) => ({
      name: item.name,
      unit_amount: Math.round(item.price * 100),
      quantity: item.quantity,
    }));
  
    if (getSubtotal() < 75 && getSubtotal() > 0) {
      payloadItems.push({
        name: "Delivery Fee",
        unit_amount: 1000, // $10 in cents
        quantity: 1,
      });
    }
  
    const payload = { items: payloadItems };
    

    fetch(
      'https://api.the-brik.com/create-payment-link',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.payment_link_url) {
          window.location.href = data.payment_link_url;
        } else {
          console.error('Error creating payment link:', data.error);
        }
      })
      .catch((error) => console.error('Error during checkout:', error));
  };

  // Calculate how much more is needed for free shipping (if under $75).
  const amountNeededForFreeShipping = 75 - getSubtotal();

  return (
    <div>
      <Header />
      <div className="cart-container">
        <h1 className="cart-title">Your Cart</h1>

        {/* Only display the free shipping banner if there are items in the cart */}
        {cart.length > 0 && (
          <div className="free-shipping-banner">
            {getSubtotal() >= 75 ? (
              <p>
                <strong>Congratulations!</strong> You qualify for free shipping!
              </p>
            ) : (
              <p>
                <strong>Spend ${amountNeededForFreeShipping.toFixed(2)} more</strong> to get free shipping on your order (orders over $75).
              </p>
            )}
          </div>
        )}

        {cart.length === 0 ? (
          <p className="empty-cart">Your cart is empty.</p>
        ) : (
          <>
            <div className="cart-items">
              {cart.map((item) => (
                <div key={item.id} className="cart-item">
                  <Link to={item.link} className="cart-image-link">
                    <img
                      src={item.images ? item.images[0] : item.image}
                      alt={item.name}
                      className="cart-image"
                    />
                  </Link>
                  <div className="cart-item-details">
                    <Link to={item.link} className="cart-item-name">
                      <h3>{item.name}</h3>
                    </Link>
                    <p>${item.price.toFixed(2)}</p>
                    <div className="quantity-controls">
                      <button className="quantity-btn" onClick={() => handleDecrement(item.id)}>
                        <FaMinus />
                      </button>
                      <span className="quantity">{item.quantity}</span>
                      <button className="quantity-btn" onClick={() => handleIncrement(item.id)}>
                        <FaPlus />
                      </button>
                    </div>
                  </div>
                  <button className="remove-btn" onClick={() => removeFromCart(item.id)}>
                    <FaTrash />
                  </button>
                </div>
              ))}
            </div>
            <div className="checkout-section">
              <div className="cart-summary">
                <p>Subtotal: ${getSubtotal().toFixed(2)}</p>
                <p>
                  Shipping:{' '}
                  {getSubtotal() >= 75 ? (
                    <span>
                      <del>$10.00</del> Free Shipping
                    </span>
                  ) : (
                    `$${getShippingCost().toFixed(2)}`
                  )}
                </p>
                <h2>Total: ${getGrandTotal()}</h2>
                <button className="checkout-btn" onClick={handleCheckout}>
                  Proceed to Checkout
                </button>
              </div>
            </div>
          </>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default Cart;
